/** N標記 */
export enum OrderSpecialRuleEnum {
    /** 會申報會計價 */
    A0_ApplyPay = 0,
    /** 申報不計價 */
    A1_Apply = 1,
    /** 不申報計自費價 */
    A2_SelfPayment = 2,
    /** 不申報不計價要列印 */
    A3_FreeAndPrint = 3,
    /** 不申報不計價不列印 */
    A4_FreeNotPrint = 4,
    /** 申報計價不列印 */
    A5_ApplyNotPrint = 5,
    /** 檢驗外送代檢自行申報 */
    A6_ExtTestSelfApply = 6,
    /** 檢驗外送代檢代申報 */
    A7_ExtTest = 7,
    /** 本藥為自調 */
    // A8_SelfDispensing = 8,
    /** 特材或針劑交付 */
    A9_SpecialDelivery = 9,
    /** 交付藥材一律印出 */
    // A10_PrintAllDrugs = 10
        /** 強制申報計價 */
    A11_SpecApplyPay = 11
}

export const PriceSPRule = [
    null,
    OrderSpecialRuleEnum.A0_ApplyPay,
    OrderSpecialRuleEnum.A5_ApplyNotPrint,
    OrderSpecialRuleEnum.A6_ExtTestSelfApply,
    OrderSpecialRuleEnum.A11_SpecApplyPay

  ];
export const LabHospSPRule = [
    OrderSpecialRuleEnum.A1_Apply,
    OrderSpecialRuleEnum.A6_ExtTestSelfApply,
    OrderSpecialRuleEnum.A7_ExtTest,
    OrderSpecialRuleEnum.A11_SpecApplyPay

  ];
export const OrderSpecialRuleDesc: { text: string, value: number }[] =
  [{ text: '會申報會計價', value: 0 },
   { text: '申報不計價', value: 1 },
   { text: '不申報計自費價', value: 2 },
   { text: '不申報不計價要列印', value: 3 },
   { text: '不申報不計價不列印', value: 4 },
   { text: '申報計價不列印', value: 5 },
   { text: '檢驗外送代檢自行申報', value: 6 },
   { text: '檢驗外送代檢代申報', value: 7 },
  //  {text: '本藥為自調', value: 8 },
   {text: '特材或針劑交付', value: 9 },
   {text: '強制申報計價', value: 11 }
  ];
  //  {text: '交付藥材一律印出', value: 10 }];


export const ControlDrugType: { text: string, value: string }[] =
[{ text: '', value: ''},
{ text: 'A 第一級', value: 'A'},
{ text: 'B 第二級', value: 'B'},
{ text: 'C 第三級', value: 'C'},
{ text: 'D 第四級', value: 'D'}]

export const BoxUnitType: { text: string, value: string }[] =
[{ text: '', value: ''},
{ text: '7 代檢', value: '7'},
{ text: 'A 病代', value: 'A'},
{ text: 'D EPO', value: 'D'}]

export const DeclRuleType: { text: string, value: number | null }[] =
[{ text: '', value: null},
{ text: '-96 申報 不計價，並排除簡表日份計算',value: -96 },
{ text: '-97 申報 不計價', value: -97},
{ text: '-98 不申報 計自費 不列印', value: -98},
{ text: '-99 不申報 不計價 抽審要印出', value: -99}]


export enum OrderEnterRuleEnum {
  /** 次劑量 */
  SingleDose = 1,
  /** 日量 */
  DailyDose = 2,
  /** 總量 */
  TotalDose = 3,
  /** 劑型量 */
  Other = 4
}

